export default __webpack_public_path__ + "static/media/smoothie-min.60f27c69.png";